export const GET_ROLES = "GET_ROLES";
export const ADD_ROLES = "ADD_ROLES"
export const EDIT_ROLES = "EDIT_ROLES"
export const SET_PROJECT = "SET_PROJECT";
export const DELETE_ROLE = "DELETE_ROLE";
export const GET_USERS_BY_ROLE = "GET_USERS_BY_ROLE";
export const GET_ROLE_BY_UUID = "GET_ROLE_BY_UUID"